import * as JobTypes from "../types/jobData";
declare const jobData: any;

/**
 * 💡 Purpose of this class:
 * On initialization, the entire job array is preprocessed ("purged"),
 * e.g. filtered by language or cleaned up.
 *
 * ✅ Result:
 * All search and filter logic will exclusively work with this
 * optimized and cleaned job array.
 */
export class JobsPreprocessor {
  public currentLang: string = "de";

  constructor() {
    this.currentLang = jobData.currentLang;
    console.log("Current Language is:", this.currentLang);
  }

  returnOnlyCurrentLangJobs(jobs: JobTypes.jobData[], lang: string): JobTypes.jobData[] {
    return jobs.filter((job) => job.language === lang);
  }
}
